import { MetaMaskInpageProvider } from "@metamask/providers";

declare global {
  interface Window {
    ethereum?: MetaMaskInpageProvider;
  }
}

export interface WalletInfo {
  address: string;
  chainId: string;
}

const getProvider = (): MetaMaskInpageProvider => {
  if (!window.ethereum) {
    throw new Error("MetaMask não está instalada");
  }
  return window.ethereum;
};

export const walletConnector = {
  isMetaMaskInstalled(): boolean {
    return Boolean(window.ethereum?.isMetaMask);
  },

  async connect(): Promise<WalletInfo> {
    const provider = getProvider();

    const accounts = (await provider.request({
      method: "eth_requestAccounts",
    })) as string[];

    if (!accounts || accounts.length === 0) {
      throw new Error("Nenhuma conta autorizada");
    }

    const chainId = (await provider.request({
      method: "eth_chainId",
    })) as string;

    return { address: accounts[0], chainId };
  },

  async getWallets(): Promise<string[]> {
    const provider = getProvider();

    const accounts = (await provider.request({
      method: "eth_accounts",
    })) as string[];

    return accounts ?? [];
  },

  async signMessage(message: string, address: string): Promise<string> {
    const provider = getProvider();

    const signature = (await provider.request({
      method: "personal_sign",
      params: [message, address],
    })) as string;

    return signature;
  },

  async signTypedData(
    typedData: Record<string, unknown>,
    address: string
  ): Promise<string> {
    const provider = getProvider();

    const signature = (await provider.request({
      method: "eth_signTypedData_v4",
      params: [address, JSON.stringify(typedData)],
    })) as string;

    return signature;
  },

  onAccountsChanged(callback: (accounts: string[]) => void): () => void {
    const provider = getProvider();
    const handler = (...args: unknown[]) => callback(args[0] as string[]);

    provider.on("accountsChanged", handler);
    return () => provider.removeListener("accountsChanged", handler);
  },


  onChainChanged(callback: (chainId: string) => void): () => void {
    const provider = getProvider();
    const handler = (...args: unknown[]) => callback(args[0] as string);

    provider.on("chainChanged", handler);
    return () => provider.removeListener("chainChanged", handler);
  },
};

export default walletConnector;
